module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_1001361.f091eb5b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetSatF/FormatoSimplificado_1001361.pdf
// module id = 348
// module chunks = 0